import React from 'react'

function ButtonRound(props) {
    const { text, color, onClick } = props
    return (
        <button className={`btn-round _`+color} onClick={onClick}>
            <h3 className="font-white">{ text }</h3>
        </button>
    )
}

export default ButtonRound
